// extracted by mini-css-extract-plugin
export default {"List":"AccreditationsList_List__RUQKE"};